// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

// Lazy-loaded Component
const Overview = lazy(() => import('pages/overview/overview'));
const OverviewRoute = (
  <Route
    path={routeName.overview}
    element={
      <PrivateRoute name={resourceName.overview}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <Overview />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default OverviewRoute;
